var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11114 6.25003C3.29524 5.97389 3.64346 5.91793 3.88892 6.12504L8 9.59376L12.1111 6.12504C12.3565 5.91793 12.7048 5.97389 12.8889 6.25003C13.073 6.52618 13.0232 6.91792 12.7777 7.12503L8.33333 10.875C8.1358 11.0417 7.8642 11.0417 7.66667 10.875L3.22225 7.12503C2.9768 6.91792 2.92705 6.52618 3.11114 6.25003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron-down-icon.0127a95130cd8065f1c880671ea65cd8.svg";
export { ForwardRef as ReactComponent };